import { arrayOf, object, string } from "prop-types";

export const allowedExtensionsProp = arrayOf(string);

export const fileShape = {
  content: object.isRequired,
  source: string.isRequired,
  hash: string.isRequired,
};
